(() => {
  const root = document.querySelector('[data-unique-cart]');
  if (!root) return;

  const status = root.querySelector('[data-cart-status]');
  const routeRoot = window.Shopify?.routes?.root || '/';

  const activeTimers = new Map();
  const removingItems = new Set();

  const showStatus = (message) => {
    if (!status) return;

    status.textContent = message;
    status.hidden = false;

    window.clearTimeout(status._hideTimer);

    status._hideTimer = window.setTimeout(() => {
      status.hidden = true;
    }, 3500);
  };

  async function enforceSingleQuantities() {
    const invalidLines = Array.from(
      root.querySelectorAll('[data-unique-cart-item]')
    ).filter((line) => {
      return Number(line.dataset.quantity || 1) > 1;
    });

    if (!invalidLines.length) return;

    try {
      for (const line of invalidLines) {
        const response = await fetch(
          `${routeRoot}cart/change.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              id: line.dataset.lineKey,
              quantity: 1
            })
          }
        );

        if (!response.ok) {
          throw new Error(
            'Menge konnte nicht korrigiert werden.'
          );
        }
      }

      window.location.reload();
    } catch (error) {
      showStatus(
        error.message ||
        'Die Menge konnte nicht auf 1 begrenzt werden.'
      );
    }
  }

  function formatRemaining(milliseconds) {
    const totalSeconds = Math.max(
      0,
      Math.ceil(milliseconds / 1000)
    );

    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${minutes}:${String(seconds).padStart(2, '0')}`;
  }

  async function removeExpiredItem(item) {
    const lineKey = String(
      item.dataset.cartLineKey ||
      item.dataset.lineKey ||
      ''
    ).trim();

    if (!lineKey || removingItems.has(lineKey)) {
      return;
    }

    removingItems.add(lineKey);
    item.classList.add('is-reservation-expired');

    const reservationStatus = item.querySelector(
      '[data-cart-reservation-status]'
    );

    if (reservationStatus) {
      reservationStatus.textContent =
        'Reservierung abgelaufen – Artikel wird entfernt …';
    }

    try {
      const response = await fetch(
        `${routeRoot}cart/change.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: lineKey,
            quantity: 0
          })
        }
      );

      const payload = await response.json();

      if (!response.ok) {
        throw new Error(
          payload.description ||
          'Artikel konnte nicht entfernt werden.'
        );
      }

      window.location.reload();
    } catch (error) {
      console.error(
        '[Cart reservation] Fehler beim Entfernen:',
        error
      );

      removingItems.delete(lineKey);
      item.classList.remove('is-reservation-expired');

      if (reservationStatus) {
        reservationStatus.textContent =
          'Reservierung abgelaufen. Bitte Seite neu laden.';
      }

      showStatus(
        error.message ||
        'Abgelaufener Artikel konnte nicht entfernt werden.'
      );
    }
  }

  function updateReservation(item) {
    const reservedUntil = Number(
      item.dataset.reservedUntil
    );

    if (
      !Number.isFinite(reservedUntil) ||
      reservedUntil <= 0
    ) {
      return;
    }

    const remaining = reservedUntil - Date.now();

    const countdown = item.querySelector(
      '[data-cart-reservation-countdown]'
    );

    if (remaining <= 0) {
      const timer = activeTimers.get(item);

      if (timer) {
        window.clearInterval(timer);
        activeTimers.delete(item);
      }

      removeExpiredItem(item);
      return;
    }

    if (countdown) {
      countdown.textContent =
        formatRemaining(remaining);
    }
  }

  function initReservations() {
    const reservationItems = Array.from(
      root.querySelectorAll(
        '[data-cart-reservation-item]'
      )
    );

    reservationItems.forEach((item) => {
      const reservedUntil = Number(
        item.dataset.reservedUntil
      );

      if (
        !Number.isFinite(reservedUntil) ||
        reservedUntil <= 0
      ) {
        return;
      }

      updateReservation(item);

      const timer = window.setInterval(() => {
        updateReservation(item);
      }, 1000);

      activeTimers.set(item, timer);
    });
  }

  root.querySelector('form')?.addEventListener(
    'submit',
    () => {
      root
        .querySelectorAll('input[name="updates[]"]')
        .forEach((input) => {
          input.value = '1';
        });
    }
  );

  enforceSingleQuantities();
  initReservations();
})();